var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"width":"35px !important"},attrs:{"src":require("@/assets/images/app/logo2.png"),"alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }